import {connect} from "react-redux";
import ObjectContacts from "./ObjectContacts";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {WithObjectComponentHOC} from "../../HOC/WithObjectComponentHOC";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {
    getAccountantSelector,
    getNotificationsSelector,
    getOwnerSelectors
} from "./selectors";
import {savePage} from "../../globalState/object/actions";
import {getMessengersListSelector} from "../../globalState/app/selectros";
import {getMessengersList} from "../../globalState/app/actions";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";


let mapStateToProps = (state) => {
    return {
        headerSubtitle: true,
        owner: getOwnerSelectors(state),
        accountant: getAccountantSelector(state),
        notification: getNotificationsSelector(state),
        messengers: getMessengersListSelector(state),
        paymentType: state.object["payment_type"],

    }
};


export default compose(connect(mapStateToProps, {
    savePage,
    getMessengersList
}), withRouter, WithObjectComponentHOC, WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(ObjectContacts);